import styled from 'styled-components'

import MenuEntryLink from '../MenuEntryLink'
import { megaMenuLinkStyles } from '../styles/desktop-menu'

export const MegaMenuList = styled.ul`
  list-style: none;
  padding-left: 1em;
  border-left: 1px solid ${({ theme }) => theme.colors.coolGray.cool250}3F;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  &:hover {
    border-left-color: ${({ theme }) => theme.colors.brand.red}7F;
  }
  & & {
    margin-left: 0.5em;
  }
`

export const MegaMenuListEntry = styled.li`
  margin-bottom: 0.5rem;
`

export const MegaMenuEntryLink = styled(MenuEntryLink)`
  ${megaMenuLinkStyles};
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  transition: color 0.35s;
  &:hover {
    color: ${({ theme }) => theme.colors.grayscale.white};
  }
`
